(() => {
  const MOBILE_MAX = 749;
  const FIRST_DELAY_MS = 900;
  const EVERY_MS = 18000;
  const HIDE_BUFFER_MS = 250;

  const isMobile = () => matchMedia(`(max-width:${MOBILE_MAX}px)`).matches;

  function initOne(el) {
    const wrapper = el.closest('.vn-bfly');
    if (!wrapper) return;

    const path = el.getAttribute('data-vn-lottie');
    if (!path) return;

    if (!window.lottie?.loadAnimation) {
      setTimeout(() => initOne(el), 200);
      return;
    }

    if (el.__vn_anim) return;

    const anim = window.lottie.loadAnimation({
      container: el,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path
    });

    el.__vn_anim = anim;

    anim.addEventListener('complete', () => {
      setTimeout(() => wrapper.classList.remove('is-visible'), HIDE_BUFFER_MS);
    });

    const playOnce = () => {
      if (!isMobile()) return;
      wrapper.classList.add('is-visible');
      anim.stop();
      anim.goToAndPlay(0, true);
    };

    setTimeout(playOnce, FIRST_DELAY_MS);
    setInterval(playOnce, EVERY_MS);

    addEventListener('resize', () => {
      if (!isMobile()) wrapper.classList.remove('is-visible');
    }, { passive: true });
  }

  function boot() {
    if (!isMobile()) return;
    document.querySelectorAll('.vn-bfly__lottie[data-vn-lottie]').forEach(initOne);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', boot)
    : boot();
})();
